const history: string[] = [];

export function clear() {
    history.splice(0, history.length);
}

export function add(id: string) {
    history.push(id);
}

export function contains(id: string): boolean {
    return history.indexOf(id) !== -1;
}
